import { makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { NewThreadButton } from "./NewThreadButton";
import { ThreadHistory } from "./ThreadHistory";

export const ThreadNav: React.FC = () => {
  const classes = useStyles();
  return (
    <nav className={classes.nav}>
      <NewThreadButton />
      <ThreadHistory />
    </nav>
  );
};

const useStyles = makeStyles({
  nav: {
    display: "flex",
    flexDirection: "column",
    paddingTop: tokens.spacingVerticalM,
    height: "100%",
    background: tokens.colorNeutralBackground4,
    overflow: "hidden", // Prevents nav container from scrolling
  },
  newThread: {
    textDecoration: "none",
    color: tokens.colorNeutralForeground1,
    "padding": tokens.spacingHorizontalL,
    ":hover": {
      "background": tokens.colorNeutralBackground4Hover,
      "cursor": "pointer",
    },
  },
  newThreadIcon: {
    "marginRight": tokens.spacingHorizontalXS,
  },
});
